<template>
<div class="wph-file-input-container">
  <input type="file" ref="files" @change="onFilesPick" :multiple="multiple" class="wph-file-input">
  <button role="button" @click="$refs.files.click()"
          class="wph-border-b wph-border-dashed wph-border-primary wph-text-sm wph-text-primary"
  >{{ buttonText }}</button>
  <span class="wph-text-sm wph-text-gray-500"> (осталось {{ max }})</span>
</div>
</template>

<script>
export default {
  name: "FilePicker",
  props: {
    multiple: { type: Boolean, default: false },
    max: { type: Number },
    buttonText: { type: String, default: 'Выбрать файлы' },
  },
  data() {
    return {
      files: '',
    }
  },
  computed: {
    iterationsNumber() {
      if (!this.max) {
        return this.files.length
      }
      if (this.max >= this.files.length) {
        return this.files.length
      }
      return this.max > 0 ? this.max : 0
    },
  },
  methods: {
    onFilesPick() {
      this.files = this.$refs.files.files
      if (!this.iterationsNumber) return;
      let formData = new FormData()
      for (let i = 0; i < this.iterationsNumber; i++) {
        const file = this.files[i]
        formData.append('files[' + i + ']', file)
      }
      formData.append('test', 'test text')
      this.$emit('form-data-ready', formData)
      this.$refs.files.value = ''
    },
  },
}
</script>

<style scoped>
  .wph-file-input-container {
    position: relative;
    overflow-x: hidden;
  }
  .wph-file-input {
    position: absolute;
    top: -500px;
  }
</style>